export default __webpack_public_path__ + "static/media/bookmark-full.fc4fde76.svg";